const TOKEN_COOKIE_NAME = 'PersoTKN';
const SESSION_COOKIE_NAME = 'token';
const DEFAULT_DOMAIN = 'https://personalizacion.lanacion.com.ar/v3';
const cookie = require('@ln/cookie');

const { LN } = window;

export const ConfigProvider = (domain = DEFAULT_DOMAIN, config = {}) => {
  const version = 2;
  const token = config.token || cookie.getValue(config.tokenCookieName || TOKEN_COOKIE_NAME);
  const session = config.session || ((cookie.getValue(config.sessionCookieName || SESSION_COOKIE_NAME) || '').split('-', 1));

  return () => ({
    domain,
    token,
    session,
    version
  });
};

export const DataProvider = () => ({ obtenerTemas: () => LN.Preferencias.Categories || [], obtenerNotaId: () => LN.current.notaId });

export const Providers = {
  ConfigProvider,
  DataProvider
};

export default Providers;



// WEBPACK FOOTER //
// ./~/@ln/personalizacion/laNacionProvider.js